/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 8:25 PM
 *
 */

type RoleType = 'org_admin' | 'org_operator' | 'patient' | 'individual' | string;
// If components for these tabs are not found in this project. Copy them from the Main Dashboard Project.
export type TabType =
  | 'overview'
  | 'members'
  | 'subscriptions'
  | 'billing'
  | 'tests'
  | 'devices'
  | 'settings'
  | 'medical history'
  | 'doctors'
  | 'patients';

/**
 *
 * @param {RoleType} role to generate tabs
 * @return {TabType[]} array of tabs
 */
export function getTabItemsForRole(role: RoleType): TabType[] {
  switch (role) {
    case 'school_admin':
      return ['overview', 'subscriptions', 'devices'];

    case 'teacher':
    case 'school_teacher':
      return ['overview', 'tests', 'medical history'];

    case 'student':
    case 'school_student':
    case 'patient':
    case 'school_operator':
      return ['overview', 'tests', 'medical history', 'devices'];

    default:
      return ['overview'];
  }
}
